// extracted by css-extract-rspack-plugin
export default {"nowrap":"js072uU_5CEzQiJ8","marker":"Ng1ge11c8I1Lyaed","link":"ZYgGJQ7BcO0zj0or","criticalTag":"OY2L4rNAvpgfeaJE"};